import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { DateField, MonthField } from '@/components/ui/date-field';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PartnershipSettlements() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [rows, setRows] = useState([]);
  const load = useCallback(() => axios.get(`${API}/api/admin/partnerships/summary`, { params: { month } }).then(r => setRows(r.data.partnerships || [])).catch(() => {}), [month]);
  useEffect(() => { load(); }, [load]);
  const save = async (r, patch) => {
    try { await axios.put(`${API}/api/admin/partnerships/${r.tag}/settlement`, { month, status: r.status, received_date: r.received_date, ...patch }); load(); }
    catch { toast.error('Erro ao guardar'); }
  };
  if (!rows.length) return null;
  return (
    <div className="mt-4 pt-4 border-t border-brand-border/50" data-testid="partnership-settlements">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-xs text-purple-600 font-medium uppercase tracking-wider">Parcerias: consultas e recebimento</h4>
        <MonthField value={month} onChange={e => setMonth(e.target.value)} className="text-xs border border-brand-border rounded-lg px-2 py-1" data-testid="partnership-month" />
      </div>
      <div className="space-y-2">
        {rows.map(r => (
          <div key={r.tag} className="bg-purple-50/50 border border-purple-100 rounded-xl p-3" data-testid={`partnership-row-${r.tag}`}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-medium text-brand-text">{r.partner_name}</span>
              <span className="text-xs text-purple-600 font-semibold" data-testid={`partnership-consults-${r.tag}`}>{r.consultations} consultas</span>
            </div>
            <div className="flex flex-wrap items-center gap-3 text-[11px] text-brand-muted">
              {r.percentage > 0 && <span>{r.percentage}% nutricionista</span>}
              {r.payment_handler && <span>Pago por: {r.payment_handler.charAt(0).toUpperCase() + r.payment_handler.slice(1)}</span>}
              <select value={r.status} onChange={e => save(r, { status: e.target.value })} className="border border-brand-border rounded-lg px-2 py-1 bg-white text-xs" data-testid={`partnership-status-${r.tag}`}>
                <option value="a_receber">A receber</option><option value="recebido">Recebido</option>
              </select>
              {r.status === 'recebido' && <DateField key={r.received_date} defaultValue={r.received_date || ''} onBlur={e => { if (e.target.value && e.target.value !== r.received_date) save(r, { received_date: e.target.value }); }} className="border border-brand-border rounded-lg px-2 py-1 text-xs" data-testid={`partnership-received-${r.tag}`} />}
            </div>
          </div>
        ))}
        <p className="text-[10px] text-brand-muted">Estes valores não entram no total recebido das pacientes.</p>
      </div>
    </div>
  );
}
